exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__title[data-v-4e1a7f22] {\n  font-family: Arial,Tahoma,sans-serif;\n  font-weight: 100;\n  font-size: 24px;\n}\n.modal__body[data-v-4e1a7f22] {\n  padding: 20px;\n}\n.modal__footer[data-v-4e1a7f22] {\n  float: left;\n}\n", ""]);

// exports
